import React, {useState} from "react";

import { Box, Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";
import {formatDate, getQueryString, readableDate} from "../../utils";
import axios from "axios";
import Spinner from "react-spinner-material";
import useSelect from "../../hooks/useSelect";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import {usePaymentTypesData} from "../../hooks/usePaymentTypesData";
import {getDepartmentsData, getPaymentTypesData} from "../../state/selectors";
import {useSelector} from "react-redux";
import LoadingSpinner from "../Utils/Spinner";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import Nav from "../Nav/Nav";
import {ToastContainer, toast} from "react-toastify";

export default function Reports({endpoint}) {

  document.title = "Reports";

  var max = new Date().getFullYear()
  var min = 2019;
  var years = [];

  for (var i = max; i >= min; i--) {
    years.push(i)
  }

  const [month, monthInput] = useSelect({
    label: "Month",
    options: [
      {name: "January", value: 1},
      {name: "February", value: 2},
      {name: "March", value: 3},
      {name: "April", value: 4},
      {name: "May", value: 5},
      {name: "June", value: 6},
      {name: "July", value: 7},
      {name: "August", value: 8},
      {name: "September", value: 9},
      {name: "October", value: 10},
      {name: "November", value: 11},
      {name: "December", value: 12}
    ],
    initialValue: 1,
  });

  const [year, yearInput] = useSelect({
    label: "Year",
    options: years.map((year) => {
      return {name: year, value: year}
    }),
    initialValue: max,
  });
  const [startDate, startDateInput] = useInput({
    type: "date",
    label: "Start Date",
    initialValue: null
  });

  const [paymentTypeStartDate, paymentTypeStartDateInput] = useInput({
    type: "date",
    label: "Start Date",
    initialValue: null
  });

  const [paymentTypeEndDate, paymentTypeEndDateInput] = useInput({
    type: "date",
    label: "End Date",
    initialValue: null
  });

  const [capReportDate, capReportDateInput] = useInput({
    type: "date",
    label: "End Date",
    initialValue: null
  });

  const paymentTypesLoaded = usePaymentTypesData({});
  const departmentsLoaded = useDepartmentsData({});
  const paymentTypes = useSelector(getPaymentTypesData);
  const departments = useSelector(getDepartmentsData);

  const paymentTypeObjects = paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};


  const [paymentType, setPaymentType] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [reportErrored, setReportErrored] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(0);

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  }

  const [endDate, endDateInput] = useInput({
    type: "date",
    label: "End Date",
    initialValue: null
  });

  const [monthlyDate, monthlyDateInput] = useInput({
    type: "date",
    label: "Select any date in the month you wish to run the report for",
    initialValue: null
  });

  const onClickNoParams = reportType => {
    const fileName = `${reportType}-${readableDate(formatDate(new Date(Date.now())))}.csv`;
    onClick(reportType, "", fileName)
  };

  const onClickMonthly = reportType => {
    const queryString = getQueryString({year: year, month: month});
    const fileName = `${reportType}-${month}/${year}.csv`;

    onClick(reportType, queryString, fileName)
  };
  const onClickStartEnd = (reportType, start, end, paymentType) => {
    if (!start || !end || !paymentType) {
      toast.error(
        `Please specify a valid report range and type`, {position: "top-right"});
    } else {
      const queryString = getQueryString({start: start, end: end, paymentType: paymentType.id});
      const fileName = `${reportType}-${paymentType.name}-${readableDate(start)}-${readableDate(
        end
      )}.csv`;
      onClick(reportType, queryString, fileName)
    }
  }
  const onClickRange = reportType => {
    const queryString = getQueryString({start: startDate, end: endDate});
    const fileName = `${reportType}-${readableDate(startDate)}-${readableDate(
      endDate
    )}.csv`;

    if (!startDate || !endDate) {
      toast.error(
        `Please specify a valid report range`, {position: "top-right"});
    } else {
      onClick(reportType, queryString, fileName)
    }
  };

  const onClick = (reportType, queryString, filename) => {
    setModalOpen(true);
    if(queryString){
      queryString += `&department=${selectedDepartment}`
    }
    else{
      queryString += `?department=${selectedDepartment}`
    }

    const method = "get";
    const url =
      endpoint +
      reportType +
      queryString;
    const conf = {
      method,
      url
    };
    axios(conf).then(({data}) => {
      setModalOpen(false);
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", filename); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    }).catch(() => {
      setReportErrored(true)
    });
  };
  if(!paymentTypesLoaded || !departmentsLoaded){
    return (
      <div>
        <Nav/>
        <LoadingSpinner/>
      </div>
    )
  }
  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <div>
      <Nav/>
      <Box>
        <h1 className="title">Reports</h1>
        <Columns isMultiline>
          <Column>
            <DepartmentPicker
              selectedDepartment={selectedDepartment}
              departments={departments}
              onDepartmentChange={onDepartmentChange}
            />
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title size="3">Date Range Report</Title>
        <Columns isMultiline>
          {startDateInput}
          {endDateInput}
        </Columns>
        <Columns isMultiline>
          <Column>
            <Button
              color="success"
              onClick={() => onClickRange("financedepreciationreport")}
            >
              Depreciation Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickRange("financegrantreport")}
            >
              Grant Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickRange("fleetvaluereport")}
            >
              Fleet Value Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickRange("vehiclevatreport")}
            >
              Vehicle VAT Report
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title size="3">Monthly Finance Report</Title>
        <Columns isMultiline>
          {monthInput}
          {yearInput}
          <Column></Column>
          <Column></Column>
          <Column></Column>
          <Column></Column>
          <Column></Column>
          <Column></Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Button
              color="success"
              onClick={() => onClickMonthly("monthlyfinancehpinterestreport")}
            >
              Fixed Rate Interest Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickMonthly("financehireagreementreport")}
            >
              Hire Agreement Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickMonthly("leaseagreementreport")}
            >
              Lease Agreement Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickMonthly("financevariablerateinterestreport")}
            >
              Variable Rate Interest Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickMonthly("financestockingplaninterestreport")}
            >
              Stocking Plan Interest Report
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Vehicle Details Reports</Title>
        <Columns isMultiline>
          <Column>
            <Button
              color="success"
              onClick={() => onClickNoParams("inspectionreport")}
            >
              Inspections Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClickNoParams("vehiclereport")}
            >
              Full Vehicle Details Report
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Cap Reports</Title>
        <Columns isMultiline>
          {capReportDateInput}
          <Column></Column>
          <Column></Column>
          <Column></Column>
        </Columns>
        <Columns isMultiline>
           <Column>
            <Button
              color="success"
              onClick={() => onClick("capdetailreport", '?date='+capReportDate, `capbreakdown-${readableDate(formatDate(new Date(Date.now())))}.csv`)}
            >
              Cap BreakDown By Vehicle Model
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Parts Reports</Title>
        <Columns isMultiline>
          <Column>
            <Button
              color="success"
              onClick={() => onClickNoParams("partlookupreport")}
            >
              Part Stock Report
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Contacts Reports</Title>
        <Columns isMultiline>
          <Column>
            <Button
              color="success"
              onClick={() => onClickNoParams("contactreport")}
            >
              All Contacts Report
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClick("contactreport", "?type=CC", "all-customers.csv")}
            >
              All Customers
            </Button>
          </Column>
          <Column>
            <Button
              color="success"
              onClick={() => onClick("contactreport", "?type=SP", "all-suppliers.csv")}
            >
              All Suppliers
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Quote Reports</Title>
        <Columns isMultiline>
          <Column>
            <Button
              color="success"
              onClick={() => onClickNoParams("quotereport")}
            >
              Quote Cost Report
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Payment Type Reports</Title>
        <Columns isMultiline>
          {paymentTypeStartDateInput}
          {paymentTypeEndDateInput}
          <Column>
            <label className="label">Payment Type</label>
            <PaymentTypePicker
              options={paymentTypes}
              editable={true}
              inlineEdit={false}
              blank={true}
              value={paymentType}
              onChange={e => setPaymentType(paymentTypeObjects[e.target.value])}
            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
             <Button
              color="success"
              onClick={() => onClickStartEnd("paymenttypereport", paymentTypeStartDate, paymentTypeEndDate, paymentType)}
            >
               Payment Type Report
            </Button>
          </Column>
        </Columns>
      </Box>
      <Modal
        closeOnBlur
        active={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setReportErrored(false)
        }}
      >
        <Modal.Content>
          <Section style={{backgroundColor: "grey"}}>
            <Box>
              {!reportErrored &&
                  <div>
                    <Title>Preparing Report</Title>
                    <Spinner
                      className="spinner-centre"
                      size={120}
                      spinnerColor={"#3273dc"}
                      spinnerWidth={2}
                    />
                  </div>
              }
              {reportErrored &&
                <div>
                  <Title>An Error has occured!</Title>
                  <p>An error occured while preparing your report</p>
                </div>
              }
              <Button
                color={"info"}
                onClick={() => setModalOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Section>
        </Modal.Content>
      </Modal>
    </div>
  );
}
